import styled from 'styled-components';

export const EmptyTableStateBorderless = styled.div`
  min-height: 250px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const TableStyled = styled.table<{
  $isScrolled: boolean;
  $isScrollable: boolean;
  $maxRows?: number;
  $rowHeight?: number;
  $isFullWidth?: boolean;
  $isFullHeight?: boolean;
  $borderRadius?: string;
  $isVerticalScrollOnly?: boolean;
  $allowRowSelect?: boolean;
}>`
  border-spacing: 0;
  margin: 0;
  width: ${(props) =>
    props.$isScrollable && !props.$isFullWidth ? `auto` : `100%`};
  height: ${(props) => (!props.$isFullHeight ? `auto` : `100%`)};
  ${(props) => !props.$isScrollable && `display: table;`}
  ${(props) =>
    props.$isScrollable &&
    !props.$isFullWidth &&
    `min-width: 100%;
    overflow-x: auto;
  display: block;
  position: relative;
  overflow-y: hidden;`}
  ${(props) =>
    props.$isVerticalScrollOnly &&
    props.$allowRowSelect &&
    `
    width: 100% !important;
    display: block !important;
    margin-bottom: 16px;
    max-height: ${
      props.$maxRows && props.$rowHeight
        ? `${props.$maxRows * props.$rowHeight + 56}px`
        : '224px'
    };
    overflow-x: hidden;
    position: relative;

    thead, tbody, tr {
      display: table;
      width: 100%;
      table-layout: fixed;
    }
    
    tbody {
      display: block;
      width: 100%;
    }
    
    /* Checkbox column should be minimal width */
    th:first-child,
    td:first-child {
      position: static !important;
      width: 48px; /* Fixed width for checkbox column */
      min-width: 48px;
      max-width: 48px;
    }
    
    /* Content columns should share remaining space equally */
    th:not(:first-child),
    td:not(:first-child) {
      width: auto;
    }
    
    th:first-child::before {
      display: none !important;
    }
  `}
  border-collapse: collapse;
  table-layout: fixed;

  th:first-child {
    position: sticky;
    left: 0;
    background-color: ${(props) =>
      props.theme.atlas.semantic.color.action.secondary.hoverFill};
    z-index: 1001;
    border-bottom: 1px solid
      ${(props) => props.theme.atlas.semantic.color.action.primary.hover};
    ${(props) =>
      !props.$isScrolled
        ? `&::before {
          content: '';
          border: none;
          z-index: -1;
          position: absolute;
          top: 0;
          bottom: 0;
          left: 100%;
          background: linear-gradient(to right, rgba(0,0,0,0.3), transparent);
          width: 20px;
          opacity: 0.2;
          height: ${
            props.$maxRows && props.$rowHeight
              ? `${(props.$maxRows + 1) * props.$rowHeight}px`
              : '10000%'
          };
          border-radius: inherit;
        }`
        : ''}
  }
  td:first-child {
    position: sticky;
    left: 0;
    background-color: inherit;
    z-index: 10;
  }
  background: ${(props) => props.theme.atlas.semantic.color.surface.default};
  ${(props) =>
    props.$borderRadius &&
    `
      border-top-left-radius: ${props.$borderRadius};
      border-top-right-radius: ${props.$borderRadius};
    `}
  ${(props) =>
    props.$borderRadius &&
    `
      tbody tr:last-child td:first-child {
        border-bottom-left-radius: ${props.$borderRadius};
      }
      tbody tr:last-child td:last-child {
        border-bottom-right-radius: ${props.$borderRadius};
      }
    `}
`;

export const TableHead = styled.thead<{ $isStickyHeader: boolean }>`
  width: 100%;
  ${({ $isStickyHeader }) => $isStickyHeader && `position: sticky;`}
  top: 0;
  z-index: 11;
`;

export const TableBody = styled.tbody`
  width: 100%;
  overflow-y: auto;
  z-index: 11;
`;

export const HeaderRowStyled = styled.tr`
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.action.secondary.hoverFill};
  height: 56px;
  width: 100%;
`;
